export default "__VITE_ASSET__BGVRI$$4__"